import * as React from "react";

// styles
const pageStyles = {
  color: "#232129",
  padding: 96,
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
};
const headingStyles = {
  marginTop: 0,
  marginBottom: 64,
  maxWidth: 320,
};
const headingAccentStyles = {
  color: "#663399",
};
const paragraphStyles = {
  marginBottom: 48,
};
const codeStyles = {
  color: "#8A6534",
  padding: 4,
  backgroundColor: "#FFF4DB",
  fontSize: "1.25rem",
  borderRadius: 4,
};
const listStyles = {
  marginBottom: 96,
  paddingLeft: 0,
};
const listItemStyles = {
  fontWeight: 300,
  fontSize: 24,
  maxWidth: 560,
  marginBottom: 30,
};

const linkStyle = {
  color: "#8954A8",
  fontWeight: "bold",
  fontSize: 16,
  verticalAlign: "5%",
};

const docLinkStyle = {
  ...linkStyle,
  listStyleType: "none",
  marginBottom: 24,
};

const descriptionStyle = {
  color: "#232129",
  fontSize: 14,
  marginTop: 10,
  marginBottom: 0,
  lineHeight: 1.25,
};

const docLink = {
  text: "Documentation",
  url: "https://www.gatsbyjs.com/docs/",
  color: "#8954A8",
};

const badgeStyle = {
  color: "#fff",
  backgroundColor: "#088413",
  border: "1px solid #088413",
  fontSize: 11,
  fontWeight: "bold",
  letterSpacing: 1,
  borderRadius: 4,
  padding: "4px 6px",
  display: "inline-block",
  position: "relative",
  top: -2,
  marginLeft: 10,
  lineHeight: 1,
};

// data
const links = [
  {
    text: "Tutorial",
    url: "https://www.gatsbyjs.com/docs/tutorial/",
    description:
      "A great place to get started if you're new to web development. Designed to guide you through setting up your first Gatsby site.",
    color: "#E95800",
  },
  {
    text: "How to Guides",
    url: "https://www.gatsbyjs.com/docs/how-to/",
    description:
      "Practical step-by-step guides to help you achieve a specific goal. Most useful when you're trying to get something done.",
    color: "#1099A8",
  },
  {
    text: "Reference Guides",
    url: "https://www.gatsbyjs.com/docs/reference/",
    description:
      "Nitty-gritty technical descriptions of how Gatsby works. Most useful when you need detailed information about Gatsby's APIs.",
    color: "#BC027F",
  },
  {
    text: "Conceptual Guides",
    url: "https://www.gatsbyjs.com/docs/conceptual/",
    description:
      "Big-picture explanations of higher-level Gatsby concepts. Most useful for building understanding of a particular topic.",
    color: "#0D96F2",
  },
  {
    text: "Plugin Library",
    url: "https://www.gatsbyjs.com/plugins",
    description:
      "Add functionality and customize your Gatsby site or app with thousands of plugins built by our amazing developer community.",
    color: "#8EB814",
  },
  {
    text: "Build and Host",
    url: "https://www.gatsbyjs.com/cloud",
    badge: true,
    description:
      "Now you’re ready to show the world! Give your Gatsby site superpowers: Build and host on Gatsby Cloud. Get started for free!",
    color: "#663399",
  },
];

// markup
const TermsPage = () => {
  return (
    <main style={pageStyles}>
      <title>Terms &amp; Conditions</title>
      <h1 style={headingStyles}>
        Terms &amp; Conditions
        <br />
      </h1>

      <p>
        By downloading or using the app, these terms will automatically apply to
        you &ndash; you should make sure therefore that you read them carefully
        before using the app. You&rsquo;re not allowed to copy, or modify the
        app, any part of the app, or our trademarks in any way. You&rsquo;re not
        allowed to attempt to extract the source code of the app, and you also
        shouldn&rsquo;t try to translate the app into other languages, or make
        derivative versions. The app itself, and all the trade marks, copyright,
        database rights and other intellectual property rights related to it,
        still belong to Vikas Budakoti.
      </p>
      <p>
        Vikas Budakoti is committed to ensuring that the app is as useful and
        efficient as possible. For that reason, we reserve the right to make
        changes to the app or to charge for its services, at any time and for
        any reason. We will never charge you for the app or its services without
        making it very clear to you exactly what you&rsquo;re paying for.
      </p>
      <p>
        The GlobalOpsNAV app stores and processes personal data that you have
        provided to us, in order to provide my Service. It&rsquo;s your
        responsibility to keep your device and access to the app secure. We
        therefore recommend that you do not jailbreak or root your device, which
        is the process of removing software restrictions and limitations imposed
        by the official operating system of your device. It could make your
        device vulnerable to malware/viruses/malicious programs, compromise your
        device&rsquo;s security features and it could mean that the GlobalOpsNAV
        app won&rsquo;t work properly or at all.
      </p>
      <p>
        The app does use third party services that declare their own Terms and
        Conditions.
      </p>
      <p>
        Link to Terms and Conditions of third party service providers used by
        the app
      </p>
      <ul>
        <li>
          <a href="about:blank">Google Play Services</a>
        </li>
        <li>
          <a href="about:blank">Google Analytics for Firebase</a>
        </li>
        <li>
          <a href="about:blank">Firebase Crashlytics</a>
        </li>
        <li>
          <a href="about:blank">Expo</a>
        </li>
      </ul>
      <p>
        You should be aware that there are certain things that Vikas Budakoti
        will not take responsibility for. Certain functions of the app will
        require the app to have an active internet connection. The connection
        can be Wi-Fi, or provided by your mobile network provider, but Vikas
        Budakoti cannot take responsibility for the app not working at full
        functionality if you don&rsquo;t have access to Wi-Fi, and you
        don&rsquo;t have any of your data allowance left.
      </p>
      <p>
        If you&rsquo;re using the app outside of an area with Wi-Fi, you should
        remember that your terms of the agreement with your mobile network
        provider will still apply. As a result, you may be charged by your
        mobile provider for the cost of data for the duration of the connection
        while accessing the app, or other third party charges. In using the app,
        you&rsquo;re accepting responsibility for any such charges, including
        roaming data charges if you use the app outside of your home territory
        (i.e. region or country) without turning off data roaming. If you are
        not the bill payer for the device on which you&rsquo;re using the app,
        please be aware that we assume that you have received permission from
        the bill payer for using the app.
      </p>
      <p>
        Along the same lines, Vikas Budakoti cannot always take responsibility
        for the way you use the app i.e. You need to make sure that your device
        stays charged &ndash; if it runs out of battery and you can&rsquo;t turn
        it on to avail the Service, Vikas Budakoti cannot accept responsibility.
      </p>
      <p>
        With respect to Vikas Budakoti&rsquo;s responsibility for your use of
        the app, when you&rsquo;re using the app, it&rsquo;s important to bear
        in mind that although we endeavour to ensure that it is updated and
        correct at all times, we do rely on third parties to provide information
        to us so that we can make it available to you. Vikas Budakoti accepts no
        liability for any loss, direct or indirect, you experience as a result
        of relying wholly on this functionality of the app.
      </p>
      <p>
        At some point, we may wish to update the app. The app is currently
        available on Android &amp; iOS &ndash; the requirements for both
        systems(and for any additional systems we decide to extend the
        availability of the app to) may change, and you&rsquo;ll need to
        download the updates if you want to keep using the app. Vikas Budakoti
        does not promise that it will always update the app so that it is
        relevant to you and/or works with the Android &amp; iOS version that you
        have installed on your device. However, you promise to always accept
        updates to the application when offered to you, We may also wish to stop
        providing the app, and may terminate use of it at any time without
        giving notice of termination to you. Unless we tell you otherwise, upon
        any termination, (a) the rights and licenses granted to you in these
        terms will end; (b) you must stop using the app, and (if needed) delete
        it from your device.
      </p>
      <p>
        <strong>Changes to This Terms and Conditions</strong>
      </p>
      <p>
        I may update our Terms and Conditions from time to time. Thus, you are
        advised to review this page periodically for any changes. I will notify
        you of any changes by posting the new Terms and Conditions on this page.
      </p>
      <p>These terms and conditions are effective as of 2021-11-30</p>
      <p>
        <strong>Contact Us</strong>
      </p>
      <p>
        If you have any questions or suggestions about my Terms and Conditions,
        do not hesitate to contact me at vbudakoti1@gmail.com.
      </p>
      <img
        alt="Gatsby G Logo"
        src="data:image/svg+xml,%3Csvg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 2a10 10 0 110 20 10 10 0 010-20zm0 2c-3.73 0-6.86 2.55-7.75 6L14 19.75c3.45-.89 6-4.02 6-7.75h-5.25v1.5h3.45a6.37 6.37 0 01-3.89 4.44L6.06 9.69C7 7.31 9.3 5.63 12 5.63c2.13 0 4 1.04 5.18 2.65l1.23-1.06A7.959 7.959 0 0012 4zm-8 8a8 8 0 008 8c.04 0 .09 0-8-8z' fill='%23639'/%3E%3C/svg%3E"
      />
    </main>
  );
};

export default TermsPage;
